import { useGetBulkActionBtnConfig, useGetModulesData } from "@/hooks/AllCustomHooks";
import { handleAddExactBtnClick, isTarget } from "@/ts/utils";
import { ICellRendererParams } from "ag-grid-community";
import { Input } from "antd";
import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { useSelector } from "react-redux";
import { IModal } from "../modals/CustomModal";
import { DISABLED_MATCH_TYPES, KEYWORD_MATCH_TYPES } from "@/ts/constants";
import { isNull } from "underscore";

interface IKeywordAddBidCellRenderer extends ICellRendererParams {
    hasApplyButton: boolean;
    hasCancelButton: boolean;
    isThirdPartyRequestOnApply: boolean;
    origin: string;
    isDisabled: boolean;
    column: any;
}

const KeywordAddBidCellRenderer: React.FC<IKeywordAddBidCellRenderer> = (params) => {
    const identifier = `${params.data.sys_ams_keyword_id}-${params.data.keyword_name}-cpm-field`;
    const addAsExactConfig = useGetBulkActionBtnConfig();
    const isSearchTermExact = useSelector((state: IModal) => state.isSearchTermExact.value);
    const customModalDisp = useSelector((state: IModal) => state.customModalDisp.value);
    const [loading, setLoading] = useState(false);
    const [disabled] = useState(
        isSearchTermExact ||
        (
            !KEYWORD_MATCH_TYPES.includes(
                params.data.match_type.toLowerCase()
            ) &&
            isNull(isTarget(params.data.keyword_name))
        ) ||
        DISABLED_MATCH_TYPES.includes(
            params.data.match_type.toLowerCase()
        )
    );

    const gridParams = useGetModulesData({
        type: "grid-params",
        subGridType: customModalDisp ? "campaigns" : "addAsExact"
    });

    return (
        <>
            {params.node.rowPinned ? null : (
                <div
                    className={gridParams.isBadgeRequired ? "my-1" : ""}
                >
                    <Input
                        style={{
                            border: "1.5px solid #ccc",
                            width: "100px",
                            ...(!gridParams.isBidRequired && { display: "none" })
                        }}
                        bordered
                        disabled={disabled}
                        type="number"
                        id={identifier}
                        data-id={identifier}
                        defaultValue={Math.floor(params.data[params.column.colId])}
                        onChange={(e) => {
                            params.node.setData({
                                ...params.data,
                                [params.column.colId]: +e.target.value
                            });
                        }}
                    />
                    <button
                        id={`${identifier}-button`}
                        className="btn btn-sm btn-success mx-2"
                        disabled={disabled}
                        onClick={() =>
                            handleAddExactBtnClick({
                                matchType: "exact",
                                addAsExactData: [params.data],
                                addAsExactConfig,
                                bidField: gridParams.bidColumn,
                                isIndividualUpdate: true,
                                setAddLoader: setLoading,
                            })
                        }
                    >
                        {loading ? (
                            <i
                                className="spinner-border"
                                style={{ width: "1em", height: "1em" }}
                            />
                        ) : (
                            <FaPlus style={{ transform: "translateY(-10%)" }} />
                        )}
                    </button>
                </div>
            )}
        </>
    );
};

export default KeywordAddBidCellRenderer;
